(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["petwell-story-caroulsed"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(sectionId) {
    var track = document.getElementById('pw-story-track-' + sectionId);
    if (!track) return;

    var wrapper = track.closest('.pw-story__track-wrapper');
    var dots    = document.querySelectorAll('[data-target="pw-story-track-' + sectionId + '"].pw-story__dot');
    var prevBtn = wrapper.querySelector('.pw-story__arrow--prev');
    var nextBtn = wrapper.querySelector('.pw-story__arrow--next');
    var slides  = track.querySelectorAll('.pw-story__slide');
    var total   = slides.length;
    var current = 0;

    function isMobile() {
      return window.innerWidth <= 768;
    }

    function setSlideWidths() {
      if (isMobile()) {
        slides.forEach(function (slide) {
          slide.style.minWidth = '';
        });
      } else {
        var w = track.offsetWidth;
        slides.forEach(function (slide) {
          slide.style.minWidth = w + 'px';
        });
      }
    }

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;

      if (isMobile()) {
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
      } else {
        var w = track.offsetWidth;
        track.style.transform = 'translateX(-' + (current * w) + 'px)';
      }

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    setSlideWidths();
    goTo(0);

    window.addEventListener('resize', setSlideWidths);

    wrapper.addEventListener('click', function (e) {
      var arrow = e.target.closest('.pw-story__arrow');
      if (!arrow) return;
      var dir = parseInt(arrow.getAttribute('data-dir'), 10);
      goTo(current + dir);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    var touchStartX = null;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });
  }

  document.querySelectorAll('.pw-story').forEach(function (section) {
    var id = section.id.replace(/^pw-story-/, '');
    initCarousel(id);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
